import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'stepup-edit',
  async created () {
    await Promise.all([
      this.getShop(),
      this.getQuestions(),
      this.search()
    ])
    this.getDataEndflag = true
  },
  data () {
    return {
      shopId: '',
      userId: '',
      joinRestrictionDate: '',
      shopRestrictionDate: '',
      notificationStartDate: '',
      answerStartDate: '',
      endDate: '',
      questionIds: [],
      ownQuestionId: '',
      canValidate: true,
      getDataEndflag: false,
      users: '',
      questions: '',
      savingFlag: false,
      futureShopChangeExist: false,
      futureUsertypeChangeExist: false
    }
  },
  computed: {
    shops () {
      return this.$store.getters.shopsAll
    },
    joinRestrictionDateFormat () {
      return DayJs(this.joinRestrictionDate).format('YYYY-MM-DD')
    },
    shopRestrictionDateFormat () {
      return DayJs(this.shopRestrictionDate).format('YYYY-MM-DD')
    },
    notificationStartDateFormat () {
      return DayJs(this.notificationStartDate).format('YYYY-MM-DD')
    },
    answerStartDateFormat () {
      return DayJs(this.answerStartDate).format('YYYY-MM-DD')
    },
    endDateFormat () {
      return DayJs(this.endDate).format('YYYY-MM-DD')
    },
    validation: function () {
      let today = DayJs(new Date()).format('YYYY-MM-DD')
      var v = {
        shopId: !!this.shopId,
        userId: !!this.userId,
        joinRestrictionDate: !!this.joinRestrictionDate,
        shopRestrictionDate: !!this.shopRestrictionDate,
        notificationStartDate: !!this.notificationStartDate,
        notificationStartDateRange: DayJs(today).isBefore(this.notificationStartDateFormat),
        answerStartDate: !!this.answerStartDate,
        answerStartDateRange: this.notificationStartDateFormat < this.answerStartDateFormat,
        endDate: !!this.endDate,
        endDateRange: this.answerStartDateFormat < this.endDateFormat,
        questionIds: this.questionIds.length > 0,
        ownQuestionId: !!this.ownQuestionId,
        futureShopChangeExist: !this.futureShopChangeExist,
        futureUsertypeChangeExist: !this.futureUsertypeChangeExist,
        notInput: !!this.shopId &&
        !!this.userId &&
        !!this.joinRestrictionDate &&
        !!this.shopRestrictionDate &&
        !!this.notificationStartDate &&
        DayJs(today).isBefore(this.notificationStartDateFormat) &&
        !!this.answerStartDate &&
        this.notificationStartDateFormat < this.answerStartDateFormat &&
        !!this.endDate &&
        this.answerStartDateFormat < this.endDateFormat &&
        this.questionIds.length > 0 &&
        !!this.ownQuestionId &&
        !this.futureShopChangeExist &&
        !this.futureUsertypeChangeExist
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getShop () {
      await this.$store.dispatch('SHOP_ALL_GET', {callback: ''})
      .catch(err => {
        console.log(err)
        return
      })

      // 退職者一覧店舗を表示しない
      let workIndex = 0
      for (let i = 0; i < this.shops.length; i++) {
        if (this.shops[i].id == 800) {
          workIndex = i
          break
        }
      }
      if (workIndex !== 0) {
        this.shops.splice(workIndex, 1)
      }
    },
    async getQuestions () {
      let data = {}
      let res = await this.$store.dispatch('GET_QUESTION_ALL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.questions = res.questions
    },
    async search () {
      let res = await this.$store.dispatch('GET_STEPUP_DETAIL', { id: this.$route.params.id })
      .catch(err => {
        console.log(err)
        return
      })
      this.shopId = res.step_up_entry.shop_id
      this.userId = res.step_up_entry.user_id
      this.joinRestrictionDate = res.step_up_entry.join_restriction_date
      this.shopRestrictionDate = res.step_up_entry.shop_restriction_date
      this.notificationStartDate = res.step_up_entry.notification_start_date
      this.answerStartDate = res.step_up_entry.answer_start_date
      this.endDate = res.step_up_entry.end_date
      for (let i = 0; i < res.step_up_questions.length; i++) {
        this.questionIds.push(res.step_up_questions[i].question_id)
      }
      this.ownQuestionId = res.step_up_own_question.question_id
      this.getUser(this.shopId)
    },
    async getUser (shopId) {
      let res = ''
      res = await this.$store.dispatch('USER_GET_BY_SHOP', {
        data: {
          shop_id: shopId
        }
      })
      .catch(err => {
        console.log(err)
      })
      this.users = res.users
    },
    onChangeNotificationStartDate: function () {
      if (this.notificationStartDate) {
        this.joinRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(2, 'month')
        this.shopRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(1, 'month')
      } else {
        this.joinRestrictionDate = ''
        this.shopRestrictionDate = ''
      }
    },
    isChecked: function (questionId) {
      return this.questionIds.indexOf(questionId) !== -1 ? true : false
    },
    onChangeShop: function () {
      this.userId = ''
      if (this.shopId) {
        this.getUser(this.shopId)
      } else {
        this.users = ''
      }
    },
    async onClickSave () {
      if (this.savingFlag) return false
      this.savingFlag = true
      await this.$store.dispatch('STEPUP_UPDATE', {
        id: this.$route.params.id,
        data: {
          shop_id: this.shopId,
          user_id: this.userId,
          join_restriction_date: this.joinRestrictionDateFormat,
          shop_restriction_date: this.shopRestrictionDateFormat,
          notification_start_date: this.notificationStartDateFormat,
          answer_start_date: this.answerStartDateFormat,
          end_date: this.endDateFormat,
          question_ids: this.questionIds,
          own_question_id: this.ownQuestionId
        }
      })
      .catch(err => {
        console.log(err)
        return
      })

      this.$router.push('/stepup_list')
    },
    futureChangeCheck (userId) {
      this.futureShopChangeCheck(userId)
      this.futureUsertypeChangeCheck(userId)
    },
    async futureShopChangeCheck(userId) {
      let res = await this.$store.dispatch('STEPUP_FUTURE_SHOP_CHANGE_CHECK', {
        data: {
          user_id: userId
        }
      })
      .catch(err => {
        console.log(err)
        return
      })
      this.futureShopChangeExist = res.exist
    },
    async futureUsertypeChangeCheck(userId) {
      let res = await this.$store.dispatch('STEPUP_FUTURE_USERTYPE_CHANGE_CHECK', {
        data: {
          user_id: userId
        }
      })
      .catch(err => {
        console.log(err)
        return
      })
      this.futureUsertypeChangeExist = res.exist
    },
    onClickCancel: function () {
      this.$router.push('/stepup_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stepup-edit.js